<div class="top">
  <button mat-icon-button
          aria-label="Current task list" title="Current task list"
          routerLink="/current">
    <mat-icon>check</mat-icon>
  </button>

  <div class="edit-task-form" [hidden]="!dataLoaded">
    <h2>Editing Task</h2>

    <app-edit-task-form [task]="task"
        (statusChanged)="onStatusChanged($event)"
        (formSubmitted)="onSave()"></app-edit-task-form>

    <button id="button-save" (click)="onSave()" [disabled]="!formValid">
      Save
    </button>
  </div>

  <div [hidden]="dataLoaded">
    <mat-spinner></mat-spinner>
  </div>
</div>
